<template lang="pug">
  v-toolbar.col-12.align-content-center.sud-toolbar.pa-0(dense flat height="42" color="#757575")
    slot(name="action")
      v-icon.mr-2.pr-2.sud-toolbar__back(v-if="hasBackButton" @click="$router.go(-1)") reply
    v-toolbar-title.sud-toolbar-title
      slot(name="title") {{ title }}
    v-spacer
    v-toolbar-items.sud-toolbar-items
      slot

</template>

<script>
export default {
  inheritAttrs: false,
  name: 'app-toolbar',
  props: {
    title: String,
    back: Boolean
  },
  computed: {
    hasBackButton () {
      return this.back && window.history.length
    }
  }
}
</script>

<style lang="scss">
.sud-toolbar {
  border-radius: 3px;
  margin-bottom: 22px;
}
.sud-toolbar-title {
  font-family: 'Roboto Slab', serif !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 18px !important;
  line-height: 18px !important;
  letter-spacing: unset !important;

  color: #FFFFFF;
}
.sud-toolbar-items {
  align-items: center;
}
.sud-toolbar__back {
  border-right: 1px solid #C4C4C4;
}
</style>
